import { GitLabApi } from 'osep-generator-service-client-v1';
import { useApiConfig } from '../useApiConfig';

import { GITLAB_ME_KEY } from '../../utils/consts';
import { useQuery } from '@tanstack/react-query';

export const useGitLabMeQuery = () => {
  const { getApiConfig, axiosInstance } = useApiConfig();

  return useQuery({
    queryKey: [GITLAB_ME_KEY],
    queryFn: async () => {
      try {
        const apiConfig = await getApiConfig();

        const gitLabApi = new GitLabApi(apiConfig, undefined, axiosInstance);

        const identity = await gitLabApi.getGitlabIdentity();

        return {
          status: identity?.status,
          data: identity,
        };
      } catch (error: any) {
        console.error('Error:', error);

        return {
          status: error?.response?.status,
          data: error?.response?.data,
        };
      }
    },
  });
};
